// extracted by mini-css-extract-plugin
module.exports = {"divider":"FareFeatures-module__divider___DY71f"};